module.exports = __webpack_public_path__ + "img/28.5e5eed08.jpg";